<template src="./Index.html" />

<script>

import AddView from './actions/Add.vue';
import EditView from "./actions/Edit.vue";
import DetailsView from "./actions/Details.vue";

export default {
  components: {
    AddView,
    EditView,
    DetailsView,
  },
  created() {
    this.$store.dispatch("lookups/getDoctors");
    this.$store.dispatch("lookups/getLookups");

    this.getAll();
  },
  computed: {
    pageCount() {
      return Math.ceil(
        this.$store.state.appointments.totalItems / this.filters.pageSize
      );
    },
    appointments() {
      return this.$store.state.appointments.appointments;
    },
    doctors() {

      return [
        { value: 0, label: "الكل" },
        ...this.$store.state.lookups.doctors];
    },
    appointmentTypes() {
      return  [
        { value: 0, label: "الكل" },
        ...this.$store.getters["lookups/getLookupByType"](
        this.$lookupTypes.AppointmentTypes
      )];
    },
   },
  data() {
    return {
      permissions: this.$patientsManagementPermissions.AppointmentsPermissions,

      view: 0,
      itemId: 0,

      dialog: false,
      dialogType: null,
      dialogMessage: "",

      filters: {
        page: 1,
        pageSize: 10,
        appointmentTypeId: 0,
        doctorId: 0,
        fullName: null,
        phoneNo: null,
      },


      headers: [
        { text: 'نوع الحجز ', value: 'appointmentType' },
        { text: 'نوع الخدمة ', value: 'serviceName' },
        { text: 'اسم الحالة', value: 'patientName' },
        { text: 'الطبيب', value: 'doctorName' },
        { text: 'التاريخ', value: 'appointmentDate' },
        // { text: 'الوقت', value: 'time' },
        { text: "مسجل بواسطة", value: "createdBy", sortable: false },
        { text: "تاريخ التسجيل", value: "createdOn", sortable: false },
        { text: 'الحالة', value: 'status', sortable: false },
        { text: 'الاجراءات', value: 'actions', sortable: false },
      ],
    };
  },
  methods: {

    getAll(page) {
      this.filters.page = page || 1;
      this.$store.dispatch("appointments/getAll", this.filters);

    },

    addItem() {
      this.view = 1;
    },
    viewItem(item) {
      this.itemId = item.id;
      this.view = 3;
      // Implement view logic
    },
    editItem(item) {
      this.itemId = item.id;
      this.view = 2;
      // Implement edit logic
    },
    showDialog(item, type) {
      switch (type) {
        case "approval":
          this.dialogMessage = "هل انت متأكد من رغبتك تاكيد الموعد ";
          break;
        case "approvalReview":
          this.dialogMessage = "هل انت متأكد من رغبتك تاكيد المراجعة ";
          break;
        case "delete":
          this.dialogMessage = "هل انت متأكد من رغبتك إلغاء الموعد";
          break;
        // case "lock":
        //     this.dialogMessage = "هل انت متأكد من رغبتك تجميد البيانات";
        //     break;
        // case "unlock":
        //     this.dialogMessage = "هل انت متأكد من رغبتك تفعيل البيانات";
        //     break;
      }
      this.dialogType = type;
      this.itemId = item.id;
      this.dialog = true;
    },

    confirmDialog() {
      this.$store.dispatch(`appointments/${this.dialogType}`, this.itemId);
      this.cancelDialog();
    },

    cancelDialog() {
      this.dialog = false;
      this.itemId = 0;
      this.dialogMessage = "";
      this.dialogType = null;
    },
    back() {
      this.view = 0;
    }
  },
};
</script>